export const IS_DRAGGING_CLASS = 'is-dragging';
